import { Link, NavLink, Route, Routes } from "react-router-dom";
import { useState } from "react";
import "./About.css";

export default function About() {
  const [active, setActive] = useState(false);
  const Vision = () => (
    <>
      <article className="about-content">
        <h1>Our Vision</h1>
        <p>
          Hukukun farklı alanlarında sunduğumuz hizmetlerle ulusal çapta tanınan
          ve güvenilen, faaliyet gösterdiği alanlarda lider bir hukuk bürosu
          olmayı hedefliyoruz. Modern yaklaşımla etik değerlerden ödün vermeden,
          müvekkillerimize yenilikçi ve etkili çözümler sunmayı amaçlıyoruz.
        </p>
      </article>
    </>
  );
  const Mission = () => (
    <>
      <article className="about-content">
        <h1>Our Mission</h1>
        <p>
          GYK Hukuk olarak, bireysel ve kurumsal müvekkillerimize gayrimenkul ve
          inşaat hukuku, icra iflas ve konkordato, iş hukuku ve ceza hukuku gibi
          alanlarda adalet, dürüstlük ve çözüm odaklılık değerlerimizle hizmet
          sunuyoruz. Hızlı ve kaliteli çözümler üreterek müvekkillerimizin
          haklarını korumayı ve ortaya çıkabilecek her türlü uyuşmazlıkda
          müvekkillerimize gereken hukuki desteği vermeyi taahhüt ediyoruz.
        </p>
      </article>
    </>
  );
  return (
    <>
      <nav id="about-nav">
        <NavLink to="vision" onClick={() => setActive(false)}>
          <h4 className={!active ? "active-nav" : ""}>Vision</h4>
        </NavLink>
        <NavLink to="mission" onClick={() => setActive(true)}>
          <h4 className={active ? "active-nav" : ""}>Mission</h4>
        </NavLink>
      </nav>
      <Routes>
        <Route path="/vision" element={<Vision />} />
        <Route path="/mission" element={<Mission />} />
        <Route path="*" element={<Vision />} />
      </Routes>
    </>
  );
}
